import { theme } from "../config.json";
import defaultTheme from "../theme/default";
import voiceTheme from "../theme/voice";

export default { default: { default: defaultTheme, voice: voiceTheme } }[theme];
